<div id="maintanance-criteria" class="container">
  <div class="mastery-page-layout">
    @if (isScreenForSinglePatient) {
      <section class="mastery-page-section">
        <div class="mastery-page-section-header">
          <h5 class="mb-1">Current Configuration</h5>
        </div>

        <div class="mastery-page-callout">
          <div class="mastery-page-callout-copy">
            <div class="mastery-page-kicker">{{ pageModeLabel }}</div>
            <p class="mastery-page-summary mb-0">
              {{ pageSummary }}
            </p>
            <p class="mastery-page-link-row mb-0">
              Review
              <a [routerLink]="['/settings', 'mastery-criteria']">{{
                generalSettingsLinkLabel
              }}</a>
              here.
            </p>
          </div>

          @if (!hasCustomMasteryCriteria) {
            <button
              type="button"
              (click)="enableCustomMasteryCriteria()"
              class="btn btn-secondary"
            >
              Enable Patient-Specific Criteria
            </button>
          }
        </div>
      </section>
    }

    <section class="mastery-page-section">
      <div class="mastery-page-section-header">
        <h5 class="mb-1">Controls</h5>
      </div>

      @if (loadingMasteryCriteria) {
        <app-loading-indicator />
      } @else {
        <div class="mastery-page-form-card">
          <div class="mastery-page-form-group">
            <label for="ResponsePercentage">Response Percentage</label>
            <div class="mastery-page-inline-field">
              <input
                type="number"
                id="ResponsePercentage"
                name="ResponsePercentage"
                class="form-control inline-input"
                [(ngModel)]="masteryCriteria.ResponsePercentage"
                [disabled]="!hasCustomMasteryCriteria && isScreenForSinglePatient"
              />
              <span>%</span>
            </div>
            <p class="mastery-page-hint mb-0">
              {{ responsePercentageHint }}
            </p>
          </div>

          <div class="mastery-page-form-group">
            <label for="ConsecutiveDays">Consecutive Days</label>
            <input
              type="number"
              id="ConsecutiveDays"
              name="ConsecutiveDays"
              class="form-control inline-input"
              [(ngModel)]="masteryCriteria.ConsecutiveDays"
              [disabled]="!hasCustomMasteryCriteria && isScreenForSinglePatient"
            />
            <p class="mastery-page-hint mb-0">
              {{ consecutiveDaysHint }}
            </p>
          </div>

          <div class="mastery-page-form-group mastery-page-checkbox-group mb-0">
            <div class="mastery-page-checkbox-row">
              <p-checkbox
                id="FirstTrialIndependent"
                name="FirstTrialIndependent"
                [(ngModel)]="masteryCriteria.FirstTrialIndependent"
                binary="true"
                [disabled]="!hasCustomMasteryCriteria && isScreenForSinglePatient"
              />
              <label for="FirstTrialIndependent" class="mb-0"
                >First Trial Independent</label
              >
            </div>
            <p class="mastery-page-hint mb-0">
              {{ firstTrialHint }}
            </p>
          </div>
        </div>
      }

      @if (hasCustomMasteryCriteria || !isScreenForSinglePatient) {
        <div class="actions d-flex gap-2 w-100 mt-3 justify-content-between">
          <button type="button" (click)="save()" class="btn btn-primary">Save</button>
          @if (isScreenForSinglePatient && shouldShowResetToGeneralSettings) {
            <button type="button" (click)="resetToGeneralSettings()" class="btn btn-secondary">Reset to General Settings</button>
          }
        </div>
      }
    </section>
  </div>
</div>